module.exports = __webpack_public_path__ + "static/media/waves_blue.2188e2d8.png";